import React from 'react';
import './SideMenu.css';

const MENU_ITEMS = [
  {
    id: 'estimate-transfer',
    label: '広告代理店見積書集計ツール',
  },
  {
    id: 'settings',
    label: '設定',
  },
];

function SideMenu({ activeMenu, onMenuChange, isOpen, onClose }) {
  return (
    <>
      {isOpen && <div className="menu-overlay" onClick={onClose} />}

      <nav className={`side-menu ${isOpen ? 'open' : ''}`} aria-label="サイドメニュー">
        <div className="menu-close-wrapper">
          <button
            className="menu-close-button"
            type="button"
            onClick={onClose}
            aria-label="メニューを閉じる"
          >
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" aria-hidden="true">
              <path
                d="M22.5 7.5L7.5 22.5M7.5 7.5L22.5 22.5"
                stroke="#666666"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>
        <ul className="menu-list">
          {MENU_ITEMS.map((item) => (
            <li
              key={item.id}
              className={`menu-item ${activeMenu === item.id ? 'active' : ''}`}
            >
              <button
                className="menu-link"
                type="button"
                onClick={() => onMenuChange(item.id)}
              >
                <span className="menu-text">{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
}

export default SideMenu;
